/**
 * Date constants
 */

export const DATE_FORMAT_ISO = 'iso'
export const DATE_FORMAT_TIMESTAMP_SECOND = 'second' 
export const DATE_FORMAT_TIMESTAMP_MILLI = 'millisecond' 